import { CircularProgress } from "@mui/material";

export default function Loading(props: { color: "white" | "black" | "orange" }) {
    return (<CircularProgress style={{ color: props.color, width: "20px", height: "20px" }} />)
}